// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-6d70d96a] .network-preview {
  position: absolute;
  max-width: 300px;
  right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/community/network/NetworkOverview.vue","webpack://./NetworkOverview.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.network-preview){\n  position: absolute;\n  max-width: 300px;\n  right: 30px;\n}\n",":deep(.network-preview) {\n  position: absolute;\n  max-width: 300px;\n  right: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
